import { FC } from "react";

import style from "./style.module.scss";

interface Props {
	id?: string;
	label: string;
	value: string;
}

export const TablePropertyDisplay: FC<Props> = ({ id, label, value }) => {
	return (
		<div className={style.grid} id={id}>
			<label className={style.label}>{label}</label>
			<span className={style.value}>{value}</span>
		</div>
	);
};

export * from "./date";
